module.exports = __webpack_public_path__ + "img/banner01.3037eb7e.webp";